import {useEffect} from "react";
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import AOS from "aos";
import NavScrollTop from './components/NavScrollTop';
import LearnMore from './pages/learnMore';
import HomeTwo from './pages/HomeTwo';
import HomeThree from './pages/HomeThree';
import About from './pages/About';
import RecruitAndStaffService from './pages/RecruitmentAndStaffing';
import PermanentStaffing from './pages/PermanentStaffing';
import ContractStaffing from './pages/ContractStaffing';
import ContractHire from './pages/ContractHire';
import EnterpriseApplicationSolution from './pages/EnterpriseApplicationSolution';
import StaffAugmentation from './pages/StaffAugmentation';
import ITService from './pages/ITService';
import CloudService from './pages/Cloud';
import CyberSecurity from './pages/Cybersecurity';
import AIMLService from './pages/AI-ML';
import NetworkServices from './pages/NetworkServices';
import DataAnalytics from './pages/DataAnalytics';
import IdentityAccessManagement from './pages/IdentityAccessManagement';
import BusinessConsulting from './pages/BusinessConsulting';
import Service from './pages/Service';
import Industries from './pages/Industries';
import WorkDetails from './pages/WorkDetails';
import ServiceDetails from './pages/ServiceDetails';
import BlogGrid from './pages/BlogGrid';
import BlogClassic from './pages/BlogClassic';
import BlogDetails from './pages/BlogDetails';
import BlogCategories from './pages/BlogCategories';
import BlogTag from './pages/BlogTag';
import Contact from './pages/Contact';
import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en.json';

// Google Analytics
/*import ReactGA from 'react-ga';*/

// CSS File Here
import "aos/dist/aos.css";
import 'react-modal-video/scss/modal-video.scss';
import './assets/scss/style.scss';
import FMCG from "./pages/FMCG";
import AutoMobile from "./pages/AutoMobile";
import BankingAndFinance from "./pages/BankingAndFinance";
import EducationalInstitutions from "./pages/EducationalInstitutions";
import Government from "./pages/Government";
import HealthCare from "./pages/HealthCare";
import Insurance from "./pages/Insurance";
import Logistics from "./pages/Logistics";
import Retail from "./pages/Retail";
import Travel from "./pages/Travel";
import Telecommunications from "./pages/Telecommunications";
import EngineeringAndManufacturing from "./pages/EngineeringAndManufacturing";
import Career from "./pages/Careers";
import JobDetail from "./pages/JobDetail";
import B2BTravelCRMSolutions from "./pages/B2BTravelCRMSolutions";

TimeAgo.addDefaultLocale(en);

function App() {
    // Initialize Google Analytics with your tracking ID
    /*ReactGA.initialize('G-EPWG1ZX2D9');*/
  useEffect(() => {
    AOS.init({
        offset: 80,
        duration: 1000,
        once: true,
        easing: 'ease',
    });
    AOS.refresh();
    
  }, [])
  return (
      <Router>
        <NavScrollTop>
            <Routes>
              <Route path={`${process.env.PUBLIC_URL + "/"}`} element={<HomeThree />}/>
              <Route path={`${process.env.PUBLIC_URL + "/learn-more"}`} element={<LearnMore />}/>
              <Route path={`${process.env.PUBLIC_URL + "/home-two"}`} element={<HomeTwo />}/>
              <Route path={`${process.env.PUBLIC_URL + "/home-three"}`} element={<HomeThree />}/>
              <Route path={`${process.env.PUBLIC_URL + "/about"}`} element={<About />} />
              <Route path={`${process.env.PUBLIC_URL + "/services/recruitment-staffing"}`} element={<RecruitAndStaffService />} />
              <Route path={`${process.env.PUBLIC_URL + "/services/enterprise-solutions"}`} element={<EnterpriseApplicationSolution />} />
              <Route path={`${process.env.PUBLIC_URL + "/services/staff-augmentation"}`} element={<StaffAugmentation />} />
              <Route path={`${process.env.PUBLIC_URL + "/services/contract-staffing"}`} element={<ContractStaffing />} />
              <Route path={`${process.env.PUBLIC_URL + "/services/permanent-staffing"}`} element={<PermanentStaffing />} />
              <Route path={`${process.env.PUBLIC_URL + "/services/contract-to-hire"}`} element={<ContractHire />} />

              <Route path={`${process.env.PUBLIC_URL + "/it-services/cloud"}`} element={<CloudService />} />
              <Route path={`${process.env.PUBLIC_URL + "/it-services/cyber-security"}`} element={<CyberSecurity />} />
              <Route path={`${process.env.PUBLIC_URL + "/it-services/ai-ml"}`} element={<AIMLService />} />
              <Route path={`${process.env.PUBLIC_URL + "/it-services/network-services"}`} element={<NetworkServices />} />
              <Route path={`${process.env.PUBLIC_URL + "/it-services/data-analytics"}`} element={<DataAnalytics />} />
              <Route path={`${process.env.PUBLIC_URL + "/it-services/iam"}`} element={<IdentityAccessManagement />} />
              <Route path={`${process.env.PUBLIC_URL + "/it-services/business-consulting"}`} element={<BusinessConsulting />} />
              <Route path={`${process.env.PUBLIC_URL + "/it-services"}`} element={<ITService />} />

              <Route path={`${process.env.PUBLIC_URL + "/services"}`} element={<Service />} />
              <Route path={`${process.env.PUBLIC_URL + "/service-detail/:id"}`} element={<ServiceDetails />} />

              <Route path={`${process.env.PUBLIC_URL + "/products/b2b-travel-crm-solutions"}`} element={<B2BTravelCRMSolutions />} />
              <Route path={`${process.env.PUBLIC_URL + "/products"}`} element={<B2BTravelCRMSolutions />} />
              {/*<Route path={`${process.env.PUBLIC_URL + "/industries/fmcg"}`} element={<FMCG />} />
              <Route path={`${process.env.PUBLIC_URL + "/industries/automobile"}`} element={<AutoMobile />} />*/}
              <Route path={`${process.env.PUBLIC_URL + "/industries/banking-finance"}`} element={<BankingAndFinance />} />
              {/*<Route path={`${process.env.PUBLIC_URL + "/industries/education"}`} element={<EducationalInstitutions />} />*/}
              <Route path={`${process.env.PUBLIC_URL + "/industries/government"}`} element={<Government />} />
              <Route path={`${process.env.PUBLIC_URL + "/industries/health-care"}`} element={<HealthCare />} />
              <Route path={`${process.env.PUBLIC_URL + "/industries/insurance"}`} element={<Insurance />} />
              {/*<Route path={`${process.env.PUBLIC_URL + "/industries/logistics"}`} element={<Logistics />} />*/}
              <Route path={`${process.env.PUBLIC_URL + "/industries/retail"}`} element={<Retail />} />
              <Route path={`${process.env.PUBLIC_URL + "/industries/travel"}`} element={<Travel />} />
              <Route path={`${process.env.PUBLIC_URL + "/industries/telecommunication"}`} element={<Telecommunications />} />
              <Route path={`${process.env.PUBLIC_URL + "/industries/engineering-manufacturing"}`} element={<EngineeringAndManufacturing />} />
              <Route path={`${process.env.PUBLIC_URL + "/industries"}`} element={<Industries />} />


              <Route path={`${process.env.PUBLIC_URL + "/careers"}`} element={<Career />} />
              <Route path={`${process.env.PUBLIC_URL + "/jobs/:id"}`} element={<JobDetail />} />
              <Route path={`${process.env.PUBLIC_URL + "/work"}`} element={<Industries />} />
              <Route path={`${process.env.PUBLIC_URL + "/work-details/:id"}`} element={<WorkDetails />} />
              <Route path={`${process.env.PUBLIC_URL + "/blog-grid"}`} element={<BlogGrid />} />
              <Route path={`${process.env.PUBLIC_URL + "/blogs"}`} element={<BlogClassic />} />
              <Route path={`${process.env.PUBLIC_URL + "/tag/:slug"}`} element={<BlogTag />} />
              <Route path={`${process.env.PUBLIC_URL + "/category/:slug"}`} element={<BlogCategories />} />
              <Route path={`${process.env.PUBLIC_URL + "/blog/:id"}`} element={<BlogDetails />} />
              <Route path={`${process.env.PUBLIC_URL + "/contact-us"}`} element={<Contact />} />

              {/* <Route element={<NotFound />} /> */}
            </Routes>
          </NavScrollTop>
      </Router>
  );
}

export default App;
